export enum CountryFilterMode {
  Domain = 1,
  Dataroom = 2,
  DomainExcludingDataroom = 3,
  DataRoomWithEssentialDocuments = 4,
  DataRoomWithHealthAgency = 5,
}
